import React from 'react';

const ErrorPage = () => {
    return (
        <p>404</p>
    );
}

export default ErrorPage;